/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AuthorizeUserBody, GetMyUserParams, InitUserClientPayload, UserAuthorizeGet } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Logon<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Logon
   * @name AuthorizeUser
   * @request POST:/logon/authorize
   * @secure
   * @response `200` `UserAuthorizeGet` Данные авторизованного пользователя
   */
  authorizeUser = (data: AuthorizeUserBody, params: RequestParams = {}) =>
    this.request<UserAuthorizeGet, any>({
      path: `/logon/authorize`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Logon
   * @name GetMyUser
   * @request GET:/logon/getMyUser
   * @secure
   * @response `200` `UserAuthorizeGet` Данные авторизованного пользователя
   */
  getMyUser = (query: GetMyUserParams, params: RequestParams = {}) =>
    this.request<UserAuthorizeGet, any>({
      path: `/logon/getMyUser`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Logon
   * @name UnAuthorizeUser
   * @request GET:/logon/unauthorize
   * @secure
   * @response `200` `void` Success
   */
  unAuthorizeUser = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/logon/unauthorize`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Logon
   * @name InitUserClient
   * @request POST:/logon/init
   * @secure
   * @response `200` `void` Success
   */
  initUserClient = (data: InitUserClientPayload, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/logon/init`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags Logon
   * @name CheckInitClient
   * @request GET:/logon/checkInit/{ClientId}
   * @secure
   * @response `200` `void` Success
   */
  checkInitClient = (clientId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/logon/checkInit/${clientId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Logon
   * @name GetUserByToken
   * @request GET:/logon/checkJwt
   * @secure
   * @response `200` `void` Success
   */
  getUserByToken = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/logon/checkJwt`,
      method: "GET",
      secure: true,
      ...params,
    });
}
